<template>
  <div class="comment" v-loading="loading">
    <div class="search-header">
      <div class="content">
        <el-input
          size="small"
          placeholder="输入物料名称/ID查询"
          class="input-with-select"
          clearable
          v-noEmoji
          maxlength="45"
          @keyup.enter.native="handleSearch"
          v-model="searchParams.materialData"
        >
          <el-button slot="append" @click="handleSearch" icon="el-icon-search"></el-button>
        </el-input>
      </div>
    </div>
    <ContentBox class="content-list">
      <ListButton :buttonObj="buttonObj" @create="handleCreate"></ListButton>
      <Table ref="table" :props="table.props" :header="table.header" :data="table.data" />
      <pagination
        :currentpage="pager.currentPage"
        :pagesize="pager.pageSize"
        :totalcount="pager.totalCount"
        @handle-size-change="handleSizeChange"
        @handle-current-change="handleCurrentChange"
      ></pagination>
    </ContentBox>
    <!--详情-->
    <el-drawer
      :visible.sync="drawer"
      size="60%"
      :modal="false"
      :destroy-on-close="true"
      class="detail-drawer"
      :with-header="false"
    >
      <MaterialRead v-if="drawer" :mateForm="mateForm" @closeDrawer="handleCloseDrawer"></MaterialRead>
    </el-drawer>
  </div>
</template>

<script>
import ListButton from '@/components/ListButton'
import ContentBox from '@/components/common/ContentBox'
import MaterialRead from './MaterialRead'

export default {
  components: {
    ListButton,
    ContentBox,
    MaterialRead
  },
  data() {
    return {
      loading: false,
      drawer: false,
      mateForm: {},
      searchParams: {
        materialData: ''
      },
      buttonObj: {
        title: '物料',
        permissionData: 'schedule:add'
      },
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '缩略图',
            align: 'left',
            prop: 'materialIcon',
            'min-width': 100,
            render: (h, { row }) => {
              return (
                <div style="user-select: none;margin-top:10px">
                  <el-image src={row.materialIcon} lazy={true} style="width:80px;height:50px" />
                </div>
              )
            }
          },
          {
            label: '物料ID',
            align: 'left',
            prop: 'materialId',
            'min-width': 50,
            'show-overflow-tooltip': true
          },
          {
            label: '物料名称',
            align: 'left',
            prop: 'materialName',
            'min-width': 100,
            'show-overflow-tooltip': true
          },
          {
            label: '广告位',
            align: 'left',
            prop: 'adSpaceName',
            'min-width': 100,
            'show-overflow-tooltip': true
          },
          {
            label: '描述',
            align: 'left',
            prop: 'description',
            'min-width': 100,
            'show-overflow-tooltip': true
          },
          {
            label: '操作',
            align: 'left',
            'min-width': 100,
            fixed: 'right',
            render: (h, { row }) => {
              return h('div', [
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text'
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: (event) => {
                        event.stopPropagation()
                        this.showDetail(row)
                      }
                    }
                    // directives: [{
                    //   name: 'permission',
                    //   value: 'schedule:edit'
                    // }]
                  },
                  '详情'
                ),
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text'
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: (event) => {
                        event.stopPropagation()
                        this.addMaterial(row)
                      }
                    }
                    // directives: [{
                    //   name: 'permission',
                    //   value: 'schedule:dataOne'
                    // }]
                  },
                  '创建素材'
                ),
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text'
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: (event) => {
                        event.stopPropagation()
                        this.handleDelete(row)
                      }
                    }
                    // directives: [{
                    //   name: 'permission',
                    //   value: 'schedule:dataOne'
                    // }]
                  },
                  '删除'
                )
              ])
            }
          }
        ],
        data: []
      },
      pager: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0
      },
      spaceList: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.handleSearch()
      this.getSpaceList()
    },
    getSpaceList() {
      this.$service.getMaterialSpaceList().then((data) => {
        if (data && data.length > 0) {
          this.spaceList = data
        }
      })
    },
    handleSearch() {
      this.pager.currentPage = 1
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      const [pageSize, pageNo] = [this.pager.pageSize, this.pager.currentPage]
      const filter = { pageSize, pageNo, ...this.searchParams }
      this.$service
        .getMaterialPackageList(filter)
        .then((data) => {
          this.loading = false
          this.table.data = data.rows || []
          this.pager.totalCount = data.total || 0
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleSizeChange(val) {
      this.pager.pageSize = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pager.currentPage = val
      this.fetchData()
    },
    handleCreate() {
      this.$emit('create')
    },
    showDetail(row) {
      const space = this.spaceList.find(item => item.spaceId === row.spaceId)
      this.loading = true
      this.$service
        .getMaterialPackageDetail({ materialId: row.materialId })
        .then((data) => {
          this.loading = false
          this.mateForm = data
          this.mateForm.materialDatas = data.materialDatas.map(item => {
            const materialPackage = space.materialPackageList.find(pack => pack.materialKey === item.positionCode)
            item.positionName = materialPackage.name
            if (['single_select', 'multi_select'].includes(item.positionType)) {
              const optionEnum = JSON.parse(materialPackage.options).reduce((prev, next) => {
                prev[next.value + ''] = next.label
                return prev
              }, {})
              item.positionUrl = (item.positionUrl + '').split(',').map(val => optionEnum[val]).join('、')
            }
            return item
          })
          this.drawer = true
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleCloseDrawer() {
      this.drawer = false
    },
    addMaterial(row) {
      this.$emit('add-material', row)
    },
    handleDelete(row) {
      this.$confirm('确定删除此物料吗？', '提示', {
        showClose: false,
        center: true
      }).then(() => {
        this.$service.delMaterialPackage([row.materialId]).then((res) => {
          this.$message.success('操作成功!')
          this.fetchData()
        })
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.comment
  position relative
  height 100%
  .search-header
    display flex
    flex-direction row
    padding 15px 22px
    margin-bottom 16px
    background #fff
    width 100%
    border-bottom 1px solid #dcdfe6
    box-shadow 0 1px 4px 0 rgba(0, 0, 0, 0.06)
    align-items center
    justify-content space-between
    box-sizing border-box
    .content
      margin-right 10px
      .el-form-item
        margin-bottom 0px
.content-list
  margin 16px
  background #fff
  border none
>>>.el-table-button-text
  color #1890FF
>>>.el-table-button-text.is-disabled
  color #C0C4CC
</style>
